import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import PublicNavigation from '../components/PublicNavigation';
import './Auth.css';

const Terms = () => {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/signup';

  // Mark terms as viewed when user visits this page
  React.useEffect(() => {
    sessionStorage.setItem('termsViewed', 'true');
  }, []);

  return (
    <div className="auth-page">
      <PublicNavigation />
      <div className="container" style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
        <div className="auth-card" style={{ textAlign: 'left' }}>
          <h1 className="auth-title" style={{ marginBottom: '8px' }}>Terms & Conditions</h1>
          <p style={{ color: '#666', marginBottom: '24px' }}>Last updated: {new Date().toLocaleDateString()}</p>
          
          <div style={{ lineHeight: '1.6', marginBottom: '32px' }}>
            <p style={{ marginBottom: '16px' }}>
              Welcome to Playthlon! These Terms & Conditions (“Terms”) govern your use of the Playthlon website and app (the “Service” or “Platform”). By signing up, accessing, or using the Service, you agree to these Terms.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>1. Definitions</h2>
            <p style={{ marginBottom: '8px' }}>
              <strong>User</strong> means any person who uses the Service, including players, organizers, and administrators.
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>League</strong> means a sports league or competition organized on the Platform.
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Season</strong> means a defined time period in which a League runs (start date, end date, divisions, etc.).
            </p>
            <p style={{ marginBottom: '16px' }}>
              <strong>Content</strong> means any data, information, text, images, or other materials uploaded or submitted by Users.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>2. Acceptance of Terms</h2>
            <p style={{ marginBottom: '16px' }}>
              By creating an account on Playthlon, you confirm that you are at least 18 years old (or have parental consent) and that you agree to comply with these Terms. If you do not agree, you must not use the Service.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>3. Registration</h2>
            <p style={{ marginBottom: '8px' }}>
              You must register for an account to access certain Platform features and provide accurate, current information.
            </p>
            <p style={{ marginBottom: '16px' }}>
              You are responsible for safeguarding your login credentials and must notify us immediately of any suspicious or unauthorized account activity.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>4. User Roles & Permissions</h2>
            <p style={{ marginBottom: '8px' }}>
              Players can join leagues, view schedules, and submit match results if permitted.
            </p>
            <p style={{ marginBottom: '8px' }}>
              Organizers/Admins can create leagues and seasons, manage divisions, set rules, invite or remove players, and manage schedules.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Access or permissions may be limited or revoked if the Platform is misused.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>5. Use of the Service</h2>
            <p style={{ marginBottom: '8px' }}>
              You agree to use the Service solely for lawful and legitimate sports league management or participation.
            </p>
            <p style={{ marginBottom: '8px' }}>
              You must not upload or distribute content that is illegal, defamatory, discriminatory, or otherwise inappropriate.
            </p>
            <p style={{ marginBottom: '16px' }}>
              You must not attempt to hack, disrupt, reverse-engineer, or interfere with the integrity or security of the Platform.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>6. Intellectual Property</h2>
            <p style={{ marginBottom: '8px' }}>
              All intellectual property related to the Platform (software, design, branding, etc.) is owned or licensed by the Platform creator(s).
            </p>
            <p style={{ marginBottom: '8px' }}>
              You retain ownership of Content you upload but grant us a non-exclusive, worldwide, royalty-free licence to use and display that Content for the purpose of providing the Service.
            </p>
            <p style={{ marginBottom: '16px' }}>
              You must ensure that your use of the Platform and your Content does not infringe any third-party intellectual property rights.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>7. Data Protection & Privacy</h2>
            <p style={{ marginBottom: '16px' }}>
              Your personal data will be processed in accordance with our Privacy Policy. By using the Service, you consent to the data practices described there.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>8. Payments (if applicable)</h2>
            <p style={{ marginBottom: '8px' }}>
              If paid features are offered, you may be required to pay subscription or usage fees.
            </p>
            <p style={{ marginBottom: '8px' }}>
              All prices will be displayed clearly in the relevant currency at checkout or within the app.
            </p>
            <p style={{ marginBottom: '8px' }}>
              Fees are non-refundable unless explicitly stated otherwise.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Pricing may change; any changes will be clearly communicated in advance.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>9. Disclaimers & Limitation of Liability</h2>
            <h3 style={{ marginTop: '16px', marginBottom: '8px', fontSize: '1.1rem', fontWeight: '600' }}>9.1 Disclaimers</h3>
            <p style={{ marginBottom: '8px' }}>
              The Service is provided “as is” and “as available” without warranties of any kind.
            </p>
            <p style={{ marginBottom: '16px' }}>
              We are not responsible for real-world sports events, physical interactions between players, injuries, disputes, or match conduct.
            </p>
            <h3 style={{ marginTop: '16px', marginBottom: '8px', fontSize: '1.1rem', fontWeight: '600' }}>9.2 Limitation of Liability</h3>
            <p style={{ marginBottom: '16px' }}>
              To the maximum extent permitted by law, our total liability to you for any claim arising out of or relating to your use of the Service is limited to the total amount of fees you have paid in the preceding 3 months.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>10. Termination</h2>
            <p style={{ marginBottom: '8px' }}>
              <strong>By You:</strong> You may delete your account at any time.
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>By Us:</strong> We may suspend or terminate your account if you violate these Terms or misuse the Service.
            </p>
            <p style={{ marginBottom: '16px' }}>
              Certain data (e.g., match results or league history) may be retained for legitimate purposes even after account deletion.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>11. Changes to the Terms</h2>
            <p style={{ marginBottom: '16px' }}>
              We may update these Terms from time to time. When changes are made, we will notify you (e.g., by email or in-app notification). Updated Terms will take effect 1 day after notification. Continued use of the Service constitutes acceptance of the updated Terms.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>12. Governing Law & Dispute Resolution</h2>
            <p style={{ marginBottom: '16px' }}>
              These Terms are governed by the laws of England and Wales. Any disputes shall be resolved through the courts of England and Wales, unless otherwise required by applicable mandatory law.
            </p>

            <h2 style={{ marginTop: '24px', marginBottom: '12px', fontSize: '1.25rem', fontWeight: '600' }}>13. Miscellaneous</h2>
            <p style={{ marginBottom: '8px' }}>
              <strong>Severability:</strong> If any part of these Terms is found to be invalid or unenforceable, the remainder will continue in full force.
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Entire Agreement:</strong> These Terms and the Privacy Policy constitute the entire agreement between you and the Platform regarding your use of the Service.
            </p>
            <p style={{ marginBottom: '16px' }}>
              <strong>No Waiver:</strong> Failure to enforce a provision of these Terms does not waive the right to enforce it later.
            </p>
          </div>

          <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e0e0e0' }}>
            <Link to={returnTo} className="btn btn-primary btn-block">
              Back to Sign Up
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;

